import { useFormikContext } from "formik";
import { useMemo } from "react";
import { motion } from "framer-motion";
import { isAreaRequiredModules } from "../setupAssistantUtils";
import GenericInputGroup from "@components/input/inputGroup/GenericInputGroup";
import type { ClassicInputGroup } from "@typedefs/modulesInterfaces";
import { FieldType } from "@typedefs/modulesInterfaces";
import type { FinalForm } from "../SetupAssistantFinish";

export const AreaInput = () => {
	const { values } = useFormikContext<FinalForm>();
	const showArea = useMemo<boolean>(
		() =>
			values.modulesList.some((mod) => isAreaRequiredModules.includes(+mod)),
		[values.modulesList],
	);

	const area: ClassicInputGroup = {
		inputName: "area",
		label: "main.area",
		type: FieldType.CLASSIC,
		inputType: "number",
		unit: "[ha]",
	};

	return (
		<>
			{showArea && (
				<motion.div
					transition={{ duration: 0.25 }}
					className="w-50 py-2"
					animate={{ opacity: 1, height: 70 }}
					initial={{ opacity: 0, height: 0 }}
					exit={{ opacity: 0, height: 0 }}
				>
					<GenericInputGroup inputGroup={area} />
				</motion.div>
			)}
		</>
	);
}; 